import { createContext, useEffect } from 'react';
import { CLIENT_DETAILS_OPTIONS, ROBOT_ENVIRONMENT } from '../../config/constants';

type robotEnvironmentType = {
    environment: ROBOT_ENVIRONMENT;
    googleAnalyticsCode?: string;
    contactDetailsOption?: CLIENT_DETAILS_OPTIONS;
    userToken?: string;
}

export const RobotEnvironmentContext = createContext<robotEnvironmentType>({
    environment: undefined!,
    googleAnalyticsCode: undefined!,
    contactDetailsOption: undefined!,
    userToken: undefined
});

export const WithRobotEnvironment: React.FC<robotEnvironmentType> = ({
    environment,
    googleAnalyticsCode,
    contactDetailsOption,
    children,
    userToken,
}) => {
    useEffect(() => {
        console.log('Robot running in', environment, 'environment.');
    }, [environment]);

    return (
        <RobotEnvironmentContext.Provider
            value={{
                environment,
                googleAnalyticsCode,
                contactDetailsOption,
                userToken
            }}
        >
            {children}
        </RobotEnvironmentContext.Provider>
    );
};
